// !! This file is auto-generated, refer to the icon component story for more info' !!
import { SVGTemplateResult } from 'lit';
import {
  belHomeBreadcrumb,
  belSprintingFitnessHeaderButton,
} from './generated-svgs/bellinGeneralIcons';
import {
  belAching,
  belAir,
  belBadge,
  belBed,
  belBicycle,
  belBook,
  belBus,
  belCalendarAdd,
  belCalendarToday,
  belCar,
  belCellPhone,
  belChecklist,
  belCheckmark,
  belClipboard,
  belCompost,
  belComputer,
  belCycle,
  belDining,
  belDiversity,
  belDocument,
  belEnergyProgramTimeUsed,
  belEvStation,
  belForest,
  belGlobe2,
  belGlobe,
  belHandshake,
  belHeadset,
  belHeartMonitor,
  belHeart,
  belHeatPumpBalance,
  belHeat,
  belHome,
  belHospital,
  belInfo,
  belLab,
  belLaniard,
  belLeaf,
  belLightbulb,
  belLocation,
  belLock,
  belMail,
  belMask,
  belMegaphone,
  belMicroscope,
  belModeFan,
  belModelTraining,
  belMoney,
  belNetwork,
  belNotification,
  belPharmacy,
  belPhone,
  belPlusBox,
  belPrescription,
  belRecycling,
  belSettings,
  belShuttle,
  belSolarPower,
  belSprint,
  belStar,
  belStats,
  belStethoscope,
  belSun,
  belTimer,
  belWalker,
  belWaterVoc,
  belWave,
  belWeight,
  belWindPower,
} from './generated-svgs/bellinIconLibraryIcons';
import {
  belEmail,
  belFacebook,
  belInstagram,
  belLinkedin,
  belTiktok,
  belTwitter,
  belYoutube,
} from './generated-svgs/bellinSocialIcons';
import {
  accessTime,
  accordionCollapse,
  accordionExpand,
  add,
  article,
  backToTop,
  businessCenter,
  calendarV2,
  checkCircle,
  check,
  chevronCircleUp,
  chevronCircleWhite,
  chevronDown,
  chevronLeft,
  chevronRight,
  closeCircle,
  close,
  filterList,
  hamburger,
  handHeart,
  headShoulder,
  heartFolder,
  infoCircle,
  infoTriangle,
  instagram,
  laptopMedical,
  less,
  location,
  personRunning,
  pinDrop,
  pin,
  playerLeft,
  playerMobile,
  playerRight,
  provider,
  search,
  spaLeaf,
  stethoscope,
  truckMedical,
} from './generated-svgs/regularIcons';
import {
  addressBook,
  addressCard,
  alignLeft,
  alignRight,
  appleWhole,
  arrowLeft,
  arrowRightHook,
  arrowRight,
  arrowUpRightFromSquareSolid,
  bacterium,
  bell,
  biohazard,
  book,
  building,
  bullhorn,
  bus,
  calendar,
  caretDown,
  caretLeft,
  caretRight,
  caretUp,
  checkCircleSolid,
  checkSquare,
  chevronCircle,
  chevronDownSolid,
  chevronLeftSolid,
  chevronRightSolid,
  chevronUp,
  clock,
  comment,
  doubleQuote,
  envelopeSolid,
  exclamationTriangle,
  faceSmile,
  facebook,
  fax,
  file,
  globe,
  home,
  images,
  infoCircleSolid,
  laptop,
  link,
  linkedin,
  mailbox,
  mapMarkerAlt,
  microphone,
  mychart,
  paperclip,
  penNib,
  penSquare,
  phoneAlt,
  phone,
  player,
  questionCircle,
  quoteSquare,
  quote,
  searchSolid,
  star,
  timesCircle,
  times,
  twitter,
  virusCovid,
  volumeUp,
  votingBooth,
  votingLocation,
  youtube,
} from './generated-svgs/solidIcons';

export type IconList = {
  [key: string]: SVGTemplateResult;
};

export const bellinGeneral: IconList = {
  'bel-home-breadcrumb': belHomeBreadcrumb,
  'bel-sprinting-fitness-header-button': belSprintingFitnessHeaderButton,
};

export const bellinIconLibrary: IconList = {
  'bel-aching': belAching,
  'bel-air': belAir,
  'bel-badge': belBadge,
  'bel-bed': belBed,
  'bel-bicycle': belBicycle,
  'bel-book': belBook,
  'bel-bus': belBus,
  'bel-calendar-add': belCalendarAdd,
  'bel-calendar-today': belCalendarToday,
  'bel-car': belCar,
  'bel-cell-phone': belCellPhone,
  'bel-checklist': belChecklist,
  'bel-checkmark': belCheckmark,
  'bel-clipboard': belClipboard,
  'bel-compost': belCompost,
  'bel-computer': belComputer,
  'bel-cycle': belCycle,
  'bel-dining': belDining,
  'bel-diversity': belDiversity,
  'bel-document': belDocument,
  'bel-energy-program-time-used': belEnergyProgramTimeUsed,
  'bel-ev-station': belEvStation,
  'bel-forest': belForest,
  'bel-globe-2': belGlobe2,
  'bel-globe': belGlobe,
  'bel-handshake': belHandshake,
  'bel-headset': belHeadset,
  'bel-heart-monitor': belHeartMonitor,
  'bel-heart': belHeart,
  'bel-heat-pump-balance': belHeatPumpBalance,
  'bel-heat': belHeat,
  'bel-home': belHome,
  'bel-hospital': belHospital,
  'bel-info': belInfo,
  'bel-lab': belLab,
  'bel-laniard': belLaniard,
  'bel-leaf': belLeaf,
  'bel-lightbulb': belLightbulb,
  'bel-location': belLocation,
  'bel-lock': belLock,
  'bel-mail': belMail,
  'bel-mask': belMask,
  'bel-megaphone': belMegaphone,
  'bel-microscope': belMicroscope,
  'bel-mode-fan': belModeFan,
  'bel-model-training': belModelTraining,
  'bel-money': belMoney,
  'bel-network': belNetwork,
  'bel-notification': belNotification,
  'bel-pharmacy': belPharmacy,
  'bel-phone': belPhone,
  'bel-plus-box': belPlusBox,
  'bel-prescription': belPrescription,
  'bel-recycling': belRecycling,
  'bel-settings': belSettings,
  'bel-shuttle': belShuttle,
  'bel-solar-power': belSolarPower,
  'bel-sprint': belSprint,
  'bel-star': belStar,
  'bel-stats': belStats,
  'bel-stethoscope': belStethoscope,
  'bel-sun': belSun,
  'bel-timer': belTimer,
  'bel-walker': belWalker,
  'bel-water-voc': belWaterVoc,
  'bel-wave': belWave,
  'bel-weight': belWeight,
  'bel-wind-power': belWindPower,
};

export const bellinSocial: IconList = {
  'bel-email': belEmail,
  'bel-facebook': belFacebook,
  'bel-instagram': belInstagram,
  'bel-linkedin': belLinkedin,
  'bel-tiktok': belTiktok,
  'bel-twitter': belTwitter,
  'bel-youtube': belYoutube,
};

export const regular: IconList = {
  'access-time': accessTime,
  'accordion-collapse': accordionCollapse,
  'accordion-expand': accordionExpand,
  add,
  article,
  'back-to-top': backToTop,
  'business-center': businessCenter,
  'calendar-v2': calendarV2,
  'check-circle': checkCircle,
  check,
  'chevron-circle-up': chevronCircleUp,
  'chevron-circle-white': chevronCircleWhite,
  'chevron-down': chevronDown,
  'chevron-left': chevronLeft,
  'chevron-right': chevronRight,
  'close-circle': closeCircle,
  close,
  'filter-list': filterList,
  hamburger,
  'hand-heart': handHeart,
  'head-shoulder': headShoulder,
  'heart-folder': heartFolder,
  'info-circle': infoCircle,
  'info-triangle': infoTriangle,
  instagram,
  'laptop-medical': laptopMedical,
  less,
  location,
  'person-running': personRunning,
  'pin-drop': pinDrop,
  pin,
  'player-left': playerLeft,
  'player-mobile': playerMobile,
  'player-right': playerRight,
  provider,
  search,
  'spa-leaf': spaLeaf,
  stethoscope,
  'truck-medical': truckMedical,
};

export const solid: IconList = {
  'address-book': addressBook,
  'address-card': addressCard,
  'align-left': alignLeft,
  'align-right': alignRight,
  'apple-whole': appleWhole,
  'arrow-left': arrowLeft,
  'arrow-right-hook': arrowRightHook,
  'arrow-right': arrowRight,
  'arrow-up-right-from-square-solid': arrowUpRightFromSquareSolid,
  bacterium,
  bell,
  biohazard,
  book,
  building,
  bullhorn,
  bus,
  calendar,
  'caret-down': caretDown,
  'caret-left': caretLeft,
  'caret-right': caretRight,
  'caret-up': caretUp,
  'check-circle-solid': checkCircleSolid,
  'check-square': checkSquare,
  'chevron-circle': chevronCircle,
  'chevron-down-solid': chevronDownSolid,
  'chevron-left-solid': chevronLeftSolid,
  'chevron-right-solid': chevronRightSolid,
  'chevron-up': chevronUp,
  clock,
  comment,
  'double-quote': doubleQuote,
  'envelope-solid': envelopeSolid,
  'exclamation-triangle': exclamationTriangle,
  'face-smile': faceSmile,
  facebook,
  fax,
  file,
  globe,
  home,
  images,
  'info-circle-solid': infoCircleSolid,
  laptop,
  link,
  linkedin,
  mailbox,
  'map-marker-alt': mapMarkerAlt,
  microphone,
  mychart,
  paperclip,
  'pen-nib': penNib,
  'pen-square': penSquare,
  'phone-alt': phoneAlt,
  phone,
  player,
  'question-circle': questionCircle,
  'quote-square': quoteSquare,
  quote,
  'search-solid': searchSolid,
  star,
  'times-circle': timesCircle,
  times,
  twitter,
  'virus-covid': virusCovid,
  'volume-up': volumeUp,
  'voting-booth': votingBooth,
  'voting-location': votingLocation,
  youtube,
};

export const iconList: IconList = {
  ...bellinGeneral,
  ...bellinIconLibrary,
  ...bellinSocial,
  ...regular,
  ...solid,
};
